/**
 * Endpoint подписки, который последний раз доехал до бэка: сверка идёт при
 * каждом возвращении в приложение, а слать регистрацию на каждый переход из
 * фона незачем.
 *
 * Отдельный модуль без зависимостей — его чистит loginSlice, которому нельзя
 * тянуть @/shared/push.
 */
import { storage } from '@/shared/utils/storage';

const STORAGE_KEY = 'push_endpoint_sent';
const DISABLED_KEY = 'push_disabled';

export function getSentPushEndpoint(): string | null {
  return storage.get(STORAGE_KEY);
}

export function setSentPushEndpoint(endpoint: string): void {
  storage.set(STORAGE_KEY, endpoint);
}

/** Логаут снял токен с девайса — следующий вход должен отправить подписку заново */
export function clearSentPushEndpoint(): void {
  storage.remove(STORAGE_KEY);
}

/** Разрешение браузера остаётся выданным, поэтому отказ помним сами */
export function isPushDisabledByUser(): boolean {
  return storage.get(DISABLED_KEY) === '1';
}

export function setPushDisabledByUser(disabled: boolean): void {
  if (disabled) storage.set(DISABLED_KEY, '1');
  else storage.remove(DISABLED_KEY);
}
